function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getProductPrice } from '~/utils/ProductPrice';
import { useGetTranslations } from '@/composables/useGetTranslations';
import { isFeatureActiveForLocale } from '~/helpers/localeFeatures';
import { useLocalization } from '~/composables/_next/useLocalization';
export function useCustomizer() {
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var customizer = useState('customizer', function () {
    return {
      isActive: false,
      isModalActive: false,
      loading: false,
      neutralBases: [],
      neutralBase: undefined,
      isAddedToCart: false,
      recipe: undefined,
      property: undefined,
      actives: [],
      scent: undefined,
      fragrance: undefined,
      equipments: [],
      step: 1,
      productOverlay: undefined,
      error: '',
      hasDefaultNeutralBase: false
    };
  });

  /**
   * Initialize the customizer with the neutral base step.
   */
  function initializeCustomizerStep() {
    if (customizer.value.neutralBase) customizer.value.step = 2;
  }

  /**
   * Get the label for the next step button.
   * @returns {string} The translated label.
   */
  function getNextStepLabel() {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    if (customizer.value.step === 4 && !customizer.value.scent || customizer.value.step === 5 && !customizer.value.fragrance) return translate('customizer.noScentCta');
    return translate('customizer.nextStep');
  }

  /**
   * Determine if the next step CTA button should be disabled.
   * @returns {boolean} True if the button should be disabled, false otherwise.
   */
  function isNextStepCtaDisabled() {
    return customizer.value.loading || customizer.value.step === 1 && !customizer.value.neutralBase || customizer.value.step === 2 && !customizer.value.property || customizer.value.step === 3 && customizer.value.actives.length < 1;
  }

  /**
   * Move to the next step in the customizer.
   */
  function goToNextStep() {
    if (customizer.value.step === 3) {
      var _customizer$value$rec, _customizer$value$rec2, _customizer$value$rec3;
      var scents = (_customizer$value$rec = customizer.value.recipe) === null || _customizer$value$rec === void 0 ? void 0 : (_customizer$value$rec2 = _customizer$value$rec.fragrancesCollection) === null || _customizer$value$rec2 === void 0 ? void 0 : (_customizer$value$rec3 = _customizer$value$rec2.items) === null || _customizer$value$rec3 === void 0 ? void 0 : _customizer$value$rec3.reduce(function (acc, current) {
        acc.push(current.usageSentence);
        return acc;
      }, []);
      if (customizer.value.actives.find(function (i) {
        return i.type === 'oil';
      }) || !(scents !== null && scents !== void 0 && scents.length)) customizer.value.step += 3;else customizer.value.step++;
    } else if (customizer.value.step === 4 && !customizer.value.scent) customizer.value.step += 2;else customizer.value.step++;
  }

  /**
   * Move to the previous step in the customizer.
   */
  function goToPreviousStep() {
    if (customizer.value.step === 6) {
      var _customizer$value$rec4, _customizer$value$rec5, _customizer$value$rec6;
      var scents = (_customizer$value$rec4 = customizer.value.recipe) === null || _customizer$value$rec4 === void 0 ? void 0 : (_customizer$value$rec5 = _customizer$value$rec4.fragrancesCollection) === null || _customizer$value$rec5 === void 0 ? void 0 : (_customizer$value$rec6 = _customizer$value$rec5.items) === null || _customizer$value$rec6 === void 0 ? void 0 : _customizer$value$rec6.reduce(function (acc, current) {
        acc.push(current.scent);
        return acc;
      }, []);
      if (customizer.value.actives.find(function (i) {
        return i.type === 'oil';
      }) || !(scents !== null && scents !== void 0 && scents.length)) customizer.value.step -= 3;else customizer.value.step--;
    } else if (hasPreviousStep()) customizer.value.step--;
  }

  /**
   * Close the modal.
   */
  function closeModal() {
    customizer.value.isModalActive = false;
  }

  /**
   * Open the modal.
   */
  function openModal() {
    customizer.value.isModalActive = true;
  }

  /**
   * Calculate the total price of the customization.
   * @returns {number} The total price.
   */
  var totalPrice = computed(function () {
    var prices = [];
    var getPrice = function getPrice(product) {
      var _getProductPrice$spec;
      return (_getProductPrice$spec = getProductPrice(product).special) !== null && _getProductPrice$spec !== void 0 ? _getProductPrice$spec : getProductPrice(product).regular;
    };
    if (customizer.value.neutralBase) prices.push(getPrice(customizer.value.neutralBase.product));
    var _iterator = _createForOfIteratorHelper(customizer.value.actives),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var active = _step.value;
        prices.push(getPrice(active.product));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (customizer.value.fragrance) prices.push(getPrice(customizer.value.fragrance.product));
    var _iterator2 = _createForOfIteratorHelper(customizer.value.equipments),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var equipment = _step2.value;
        prices.push(getPrice(equipment.product));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    if (!prices.length) return '';
    return prices.reduce(function (acc, current) {
      return acc + current;
    }, 0);
  });

  /**
   * Set the neutral bases.
   * @param {NeutralBaseModel[]} data The neutral bases data.
   */
  function setNeutralBases(data) {
    customizer.value.neutralBases = data;
    initNeutralBase();
  }

  /**
   * Set the neutral base.
   * @param {NeutralBaseModel} data The neutral base data.
   */
  function setNeutralBase(data) {
    customizer.value.neutralBase = data;
    customizer.value.recipe = undefined;
    customizer.value.property = undefined;
    customizer.value.actives = [];
    customizer.value.scent = undefined;
    customizer.value.fragrance = undefined;
    customizer.value.equipments = [];
    customizer.value.error = '';
  }

  /**
   * Set the recipe.
   * @param {RecipeModel} data The recipe data.
   */
  function setRecipe(data) {
    customizer.value.recipe = data;
    customizer.value.property = undefined;
    customizer.value.actives = [];
    customizer.value.scent = undefined;
    customizer.value.fragrance = undefined;
    customizer.value.equipments = [];
    customizer.value.error = '';
  }

  /**
   * Set the property.
   * @param {PropertyModel} data The property data.
   */
  function setProperty(data) {
    customizer.value.property = data;
    customizer.value.actives = [];
    customizer.value.scent = undefined;
    customizer.value.fragrance = undefined;
    customizer.value.equipments = [];
    customizer.value.error = '';
  }

  /**
   * Set the actives.
   * @param {ActiveModel[]} data The actives data.
   */
  function setActives(data) {
    customizer.value.actives = data;
    customizer.value.scent = undefined;
    customizer.value.fragrance = undefined;
    customizer.value.equipments = [];
    customizer.value.error = '';
  }

  /**
   * Set the scent.
   * @param {ScentModel[]} data The scent data.
   */
  function setScent(data) {
    customizer.value.scent = data;
    customizer.value.fragrance = undefined;
    customizer.value.equipments = [];
  }

  /**
   * Set the fragrance.
   * @param {FragranceModel[]} data The fragrance data.
   */
  function setFragrance(data) {
    customizer.value.fragrance = data;
    customizer.value.equipments = [];
  }

  /**
   * Set the equipments.
   * @param {EquipmentsModel[]} data The equipments data.
   */
  function setEquipments(data) {
    customizer.value.equipments = data;
  }
  var isFeatureEnabled = isFeatureActiveForLocale(locale, ['fr', 'it']);

  /**
   * Open the customizer with an optional neutral base.
   * @param {OpenNeutralBaseModel} neutralBase The neutral base data.
   * @param {boolean} isAddedToCart Whether the item is added to the cart.
   */
  function openCustomizer() {
    var neutralBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var isAddedToCart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (isFeatureEnabled) {
      customizer.value.hasDefaultNeutralBase = !!neutralBase;
      if (neutralBase) {
        customizer.value.neutralBase = neutralBase;
        customizer.value.isAddedToCart = isAddedToCart;
        initNeutralBase();
        customizer.value.step = 2;
      }
      closeModal();
      customizer.value.isActive = true;
    }
  }

  /**
   * Initialize the neutral base if not already set.
   */
  function initNeutralBase() {
    if (customizer.value.neutralBases.length && customizer.value.neutralBase && !customizer.value.neutralBase.product) {
      customizer.value.neutralBase = customizer.value.neutralBases.find(function (i) {
        return i.name === customizer.value.neutralBase.name;
      });
    }
  }

  /**
   * Close the customizer.
   */
  function closeCustomizer() {
    customizer.value.isActive = false;
    reset();
  }

  /**
   * Determine if there is a previous step.
   * @returns {boolean} True if there is a previous step, false otherwise.
   */
  function hasPreviousStep() {
    return customizer.value.step > 2 || customizer.value.productOverlay || !customizer.value.hasDefaultNeutralBase && customizer.value.step > 1;
  }

  /**
   * Set the product overlay.
   * @param {ProductOverlayModel} data The product overlay data.
   */
  function setProductOverlay(data) {
    customizer.value.productOverlay = data;
  }

  /**
   * Close the product overlay.
   */
  function closeProductOverlay() {
    customizer.value.productOverlay = undefined;
  }

  /**
   * Toggle the loading state.
   * @param {boolean} [state=false] The loading state.
   */
  function toggleLoading() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    customizer.value.loading = state;
  }

  /**
   * Reset the customizer state.
   */
  function reset() {
    customizer.value.step = 1;
    customizer.value.neutralBase = undefined;
    customizer.value.recipe = undefined;
    customizer.value.property = undefined;
    customizer.value.actives = [];
    customizer.value.scent = undefined;
    customizer.value.fragrance = undefined;
    customizer.value.equipments = [];
    customizer.value.isAddedToCart = false;
    customizer.value.productOverlay = undefined;
  }

  /**
   * Set an error message.
   * @param {string} message The error message.
   */
  function setError(message) {
    customizer.value.error = message;
  }
  var errorPopup = useState('errorPopup', function () {
    return {
      attribute: null
    };
  });
  return {
    isFeatureEnabled: isFeatureEnabled,
    customizer: customizer,
    errorPopup: errorPopup,
    initializeCustomizerStep: initializeCustomizerStep,
    getNextStepLabel: getNextStepLabel,
    isNextStepCtaDisabled: isNextStepCtaDisabled,
    goToNextStep: goToNextStep,
    goToPreviousStep: goToPreviousStep,
    closeModal: closeModal,
    openModal: openModal,
    totalPrice: totalPrice,
    setNeutralBases: setNeutralBases,
    setNeutralBase: setNeutralBase,
    setRecipe: setRecipe,
    setProperty: setProperty,
    setActives: setActives,
    setScent: setScent,
    setFragrance: setFragrance,
    setEquipments: setEquipments,
    openCustomizer: openCustomizer,
    initNeutralBase: initNeutralBase,
    closeCustomizer: closeCustomizer,
    hasPreviousStep: hasPreviousStep,
    setProductOverlay: setProductOverlay,
    closeProductOverlay: closeProductOverlay,
    toggleLoading: toggleLoading,
    reset: reset,
    setError: setError
  };
}